if (!customElements.get('frequency-selector')) {
  class FrequencySelector extends HTMLElement {
    constructor() {
      super();
    }

    get value() {
      return this.input.value;
    }

    connectedCallback() {
      this.input = this.querySelector('input[type="number"]');
      this.updateActiveButton();
      this.updatePluralization();

      this.querySelector('.js-decrement').addEventListener('click', () => {
        if (this.input.value > parseInt(this.input.min)) {
          this.input.stepDown();
          this.input.dispatchEvent(new Event('change'));
          this.updateActiveButton();
          this.updatePluralization();
        }
      });

      this.querySelector('.js-increment').addEventListener('click', () => {
        if (this.input.value < parseInt(this.input.max)) {
          this.input.stepUp();
          this.input.dispatchEvent(new Event('change'));
          this.updateActiveButton();
          this.updatePluralization();
        }
      });
    }

    /**
     * Update the active state of the increment and decrement buttons
     */
    updateActiveButton() {
      const buttons = this.querySelectorAll('.frequency-selector__button');
      buttons.forEach((button) => {
        // Disable each button if its value is at min/max respectively

        if (button.classList.contains('js-decrement')) {
          if (this.input.value <= this.input.min) {
            button.setAttribute('disabled', 'disabled');
          } else {
            button.removeAttribute('disabled');
          }
        }

        if (button.classList.contains('js-increment')) {
          if (this.input.value >= this.input.max) {
            button.setAttribute('disabled', 'disabled');
          } else {
            button.removeAttribute('disabled');
          }
        }
      });
    }

    /**
     * Update the pluralization of the frequency label based on the input value
     */
    updatePluralization() {
      const singular = this.querySelector('.frequency-selector__singular');
      const plural = this.querySelector('.frequency-selector__plural');

      singular.classList.toggle('active', this.input.value <= 1);
      plural.classList.toggle('active', this.input.value > 1);
    }
  }
  customElements.define('frequency-selector', FrequencySelector);
}
